/*****************************************************************************************************************************************************
 * Revision History
 * 2025-04-25 TBH - Updated to set pageSize from CMS (CMS Widget Page Size => Model.PageSize => HTML pageSize hidden input => JavaScript pageSize).
 * 2025-04-26 TBH - Bug fix. Button to Event Detail page broken. Made name for Event Detail page URL consistent in model, page, & JavaScript.
 *****************************************************************************************************************************************************/
export default function eventList() {
// console.log( 'eventList()' );
  return {
    eventsList: [],
    pageSize: -1,
    totalCount: 0,
    pageCount: 0,
    currentPage: 1,
    hasMore: false,
    eventDetailPageUrl: "",
    paginate( pageNumber ) {
      this.currentPage = pageNumber;
      this.bindEventsList();
    },
    prev() {
      this.currentPage = this.currentPage - 1;
      this.bindEventsList();
    },
    next() {
      this.currentPage = this.currentPage + 1;
      this.bindEventsList();
    },
    formatDate(dateValue) {
      const options = { month: "long", day: "numeric", year: "numeric" };
      const formattedDate = new Date(dateValue).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    },
    bindEventsList() {
// console.log( 'bindEventsList(): PageSize: ' + this.pageSize + ', PageNumber: ' + this.currentPage );

      fetch("/api/EventsAPI/GetEvents", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          PageSize: this.pageSize,
          PageNumber: this.currentPage
        })
      }).then((response) => {
          return response.json();
      }).then((response) => {
// console.log( 'response: ' + JSON.stringify( response ));
          this.showLoader = false;
          if (response != undefined && response.isSuccess) {
            Array.prototype.push.apply(this.eventsList, response.events);
            this.hasMore = response.hasMore;
            this.showErrorMesage =
              this.eventsList.length <= 0 ? "No event found!" : "";
          } else {
            this.showErrorMesage = "An unknown error has occurred. Please try again later.";
          }
        });
    },

    init() {
// console.log( 'init()' );
      this.pageSize = parseInt( document.getElementById( "pageSize" ).value );
// console.log( 'pageSize: ' + this.pageSize );
      this.eventDetailPageUrl = document.getElementById( "eventDetailPageUrl" ).value;
// console.log( 'eventDetailPageUrl: ' + this.eventDetailPageUrl );
      this.bindEventsList();
    }
  };
}
